import { ContentType, Result } from '@standardnotes/domain-core';
export class GetVault {
    constructor(items) {
        this.items = items;
    }
    execute(query) {
        const vaults = this.items.getItems(ContentType.TYPES.VaultListing);
        if ('keySystemIdentifier' in query) {
            const result = vaults.find((listing) => listing.systemIdentifier === query.keySystemIdentifier);
            if (!result) {
                return Result.fail('Vault not found');
            }
            return Result.ok(result);
        }
        else {
            const result = vaults.find((listing) => { var _a; return ((_a = listing.sharing) === null || _a === void 0 ? void 0 : _a.sharedVaultUuid) === query.sharedVaultUuid; });
            if (!result) {
                return Result.fail('Shared vault not found');
            }
            return Result.ok(result);
        }
    }
}
